import whatAbout from '@/assets/data/do-que-estamos-falando';
import taxReform from '@/assets/data/reforma-tributaria';
import howDoBills from '@/assets/data/como-fizemos-as-contas';
import questionsAndAnwsers from '@/assets/data/perguntas-e-respostas';

export default {
  howDoBills,
  whatAbout,
  taxReform,
  questionsAndAnwsers,
};
